var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1755 6.4758L10.3999 11.2777V20.7221L20.1755 25.524C20.3331 25.5877 20.5041 25.6119 20.6734 25.5944C20.8427 25.5769 21.005 25.5182 21.1459 25.4237C21.2868 25.3291 21.402 25.2016 21.4812 25.0523C21.5604 24.9031 21.6011 24.7368 21.5999 24.5682V7.43163C21.6011 7.26303 21.5604 7.09673 21.4812 6.94749C21.402 6.79825 21.2868 6.67069 21.1459 6.57613C21.005 6.48157 20.8427 6.42294 20.6734 6.40544C20.5041 6.38793 20.3331 6.4121 20.1755 6.4758Z",
    stroke: "#717B8E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 11.2H6.74286C6.01541 11.2 5.31775 11.4961 4.80336 12.0232C4.28898 12.5502 4 13.2651 4 14.0106V17.9894C4 18.7348 4.28898 19.4497 4.80336 19.9767C5.31775 20.5038 6.01541 20.8 6.74286 20.8H10.4",
    stroke: "#717B8E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5L26.5 25",
    stroke: "#717B8E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOff);
export default __webpack_public_path__ + "static/media/volumeOff.eefc5a21aa95423f925b60365fefbd3e.svg";
export { ForwardRef as ReactComponent };